import $ from 'jquery';
import 'jquery.easing';
